import {
  REQUEST_EMAIL_CHANGE_REQUEST,
  REQUEST_EMAIL_CHANGE_SUCCESS,
  REQUEST_EMAIL_CHANGE_FAILURE,
  VERIFY_EMAIL_CHANGE_REQUEST,
  VERIFY_EMAIL_CHANGE_SUCCESS,
  VERIFY_EMAIL_CHANGE_FAILURE,
  RESEND_EMAIL_CHANGE_REQUEST,
  RESEND_EMAIL_CHANGE_SUCCESS,
  RESEND_EMAIL_CHANGE_FAILURE,
  CHECK_EMAIL_MIGRATION_STATUS_REQUEST,
  CHECK_EMAIL_MIGRATION_STATUS_SUCCESS,
  CHECK_EMAIL_MIGRATION_STATUS_FAILURE,
  RESET_EMAIL_MIGRATION_STATE,
} from '../../../Constants/actionTypes';
import {
  requestEmailChange as requestEmailChangeApi,
  verifyEmailChangeToken as verifyEmailChangeTokenApi,
  resendEmailChange as resendEmailChangeApi,
  checkEmailMigrationStatusApi,
} from '../../../Constants/apiService';
import { HELIXOPS_EMAIL_DOMAIN } from '../../../../Constants/emailMigration';
import { logout } from '../../../Auth/authActions';

export const EMAIL_MIGRATION_ALREADY_COMPLETED_ERROR =
  'Email migration already completed. Please login again using your @helixops.ai email.';

const getFriendlyEmailMigrationError = (error) => {
  const message = error?.message || 'Something went wrong. Please try again.';
  const normalized = message.toLowerCase();

  if (normalized.includes('migration already completed') || normalized.includes('please login again')) {
    return EMAIL_MIGRATION_ALREADY_COMPLETED_ERROR;
  }

  if (normalized.includes('already') || normalized.includes('exist') || normalized.includes('duplicate')) {
    return 'Email already exists.';
  }

  if (normalized.includes('domain') || normalized.includes('helixops')) {
    return `Invalid email domain. Please use your ${HELIXOPS_EMAIL_DOMAIN} email.`;
  }

  if (normalized.includes('expired') || normalized.includes('invalid') || normalized.includes('token')) {
    return 'Verification link expired or invalid.';
  }

  return message;
};

export const requestEmailChange = (newEmail) => async (dispatch, getState) => {
  dispatch({ type: REQUEST_EMAIL_CHANGE_REQUEST });

  const accessToken = getState().auth.accessToken;

  try {
    const data = await requestEmailChangeApi(newEmail, accessToken);
    dispatch({ type: REQUEST_EMAIL_CHANGE_SUCCESS, payload: data });
    return { success: true, data };
  } catch (error) {
    const errorMessage = getFriendlyEmailMigrationError(error);
    dispatch({ type: REQUEST_EMAIL_CHANGE_FAILURE, payload: errorMessage });
    return { success: false, error: errorMessage };
  }
};

export const verifyEmailChangeToken = (token) => async (dispatch) => {
  dispatch({ type: VERIFY_EMAIL_CHANGE_REQUEST });

  try {
    const data = await verifyEmailChangeTokenApi(token);
    dispatch({ type: VERIFY_EMAIL_CHANGE_SUCCESS, payload: data });
    return { success: true, data };
  } catch (error) {
    const errorMessage = getFriendlyEmailMigrationError(error);
    dispatch({ type: VERIFY_EMAIL_CHANGE_FAILURE, payload: errorMessage });
    return { success: false, error: errorMessage };
  }
};

export const resendEmailChange = (newEmail) => async (dispatch, getState) => {
  dispatch({ type: RESEND_EMAIL_CHANGE_REQUEST });

  const accessToken = getState().auth.accessToken;

  try {
    const data = await resendEmailChangeApi(newEmail, accessToken);
    dispatch({ type: RESEND_EMAIL_CHANGE_SUCCESS, payload: data });
    return { success: true, data };
  } catch (error) {
    const errorMessage = getFriendlyEmailMigrationError(error);
    dispatch({ type: RESEND_EMAIL_CHANGE_FAILURE, payload: errorMessage });
    return { success: false, error: errorMessage };
  }
};

export const checkEmailMigrationStatus = () => async (dispatch, getState) => {
  dispatch({ type: CHECK_EMAIL_MIGRATION_STATUS_REQUEST });

  const accessToken = getState().auth.accessToken;

  try {
    const data = await checkEmailMigrationStatusApi(accessToken);
    dispatch({ type: CHECK_EMAIL_MIGRATION_STATUS_SUCCESS, payload: data });
    return { success: true, data };
  } catch (error) {
    if (error?.status === 401 || error?.status === 403) {
      dispatch(logout());
      dispatch(resetEmailMigrationState());
      return { success: false, unauthorized: true, error: error.message };
    }

    const errorMessage = getFriendlyEmailMigrationError(error);
    dispatch({ type: CHECK_EMAIL_MIGRATION_STATUS_FAILURE, payload: errorMessage });
    return { success: false, error: errorMessage };
  }
};

export const resetEmailMigrationState = () => ({
  type: RESET_EMAIL_MIGRATION_STATE,
});
